<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap v-if="initStatus === 1">
      <v-flex xs12>
        <v-stepper :value="claimLifeCycle" class="quoteLifeCycle">
          <v-stepper-header>
            <v-stepper-step step="1" :complete="claimLifeCycle > 1">Claimant</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="claimLifeCycle > 2">Claim Item</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3" :complete="claimLifeCycle > 3">Claim Reserve</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4" :complete="claimLifeCycle > 4">Claim Summary</v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </v-flex>
      <v-flex lg8 xs12 order-lg1 order-xs2>
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
        <!-- The following dialog will work with leaveClaim Mixin (individual module to follow this structure:: just change the title) -->
        <promptLeave title="Claim" v-model="promptLeave" @exit="doExit" @saveAndExit="doSaveAndExit"></promptLeave>
      </v-flex>
      <v-flex lg4 xs12 order-lg2 order-xs1>
        <claim-quick-info></claim-quick-info>
      </v-flex>
    </v-layout>
    <loader v-else :card="false" :height="425" :init="doInit" loadText="Loading Claim Details..." errorText="Failed to load Claim Details" :loading="initStatus === 0"></loader>
  </v-container>
</template>

<script>
import ClaimQuickInfo from './ClaimQuickInfo'
import { leaveClaim } from './leaveClaim'
import PromptLeave from './leaveClaim/PromptLeave'

export default {
  computed: {
    initStatus() {
      return this.$store.state.claims.claimDetail.init
    },
    claimLifeCycle() {
      return this.$store.state.claims.claimDetail.claimLifeCycle
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('claimDetailInit')
    }
  },
  mounted() {
    if (this.initStatus !== 1) {
      this.doInit()
    }
  },
  components: {
    ClaimQuickInfo,
    PromptLeave
  },
  mixins: [
    leaveClaim
  ]
}
</script>

<style lang="scss">
</style>
